import { ACTION_TYPE_INITIALIZE } from './actionTypes';
export var initialize = function (config) { return ({
    type: ACTION_TYPE_INITIALIZE,
    config: config,
}); };
//# sourceMappingURL=actionCreators.js.map